/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { SDKClientCommunicatorInterface } from '@cred/widget-sdk-client'
import { Modal, useModal } from '@cred/react-overlay'

const HelpIconWithModalNoHoc = (props) => {
  const {
    modalName,
    color,
    scrollToModal = false,
    sdkScroll = false,
    isMobile = false,
    loadingClassName,
    smallGreyIcon,
    modalComponent: ModalComponent,
  } = props
  const blockToScroll = isMobile ? 'start' : 'center'

  const { open, close, isOpen } = useModal({ name: modalName })

  const openModalOnClick = () => {
    open()

    if (scrollToModal) document.body.scrollIntoView({ behavior: 'smooth', block: blockToScroll })

    if (sdkScroll) {
      SDKClientCommunicatorInterface.sentMessage('scrollRequest', 'top')
    }
  }
  return (
    <div>
      <i
        className={cx('cred-icon icon-help-outline', loadingClassName, smallGreyIcon, color)}
        alt="help-icon"
        onClick={openModalOnClick}
      />
      {ModalComponent && (
        <Modal name={modalName} dismissible isOpen={isOpen} close={close}>
          <ModalComponent isOpen={isOpen} close={close} />
        </Modal>
      )}
    </div>
  )
}

HelpIconWithModalNoHoc.propTypes = {
  modalName: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  scrollToModal: PropTypes.bool,
  isMobile: PropTypes.bool,
  loadingClassName: PropTypes.string,
  smallGreyIcon: PropTypes.string,
  sdkScroll: PropTypes.bool,
  modalComponent: PropTypes.elementType,
}

export { HelpIconWithModalNoHoc }

const HelpIconWithModal = HelpIconWithModalNoHoc

export default HelpIconWithModal
